import { Button } from 'antd';
import { ContainerFluid, Section, SeoTitle } from '@/components/layouts';

export default function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <Section>
      <ContainerFluid>
        <div
          role="alert"
          aria-live="assertive"
          className="mx-auto grid w-full max-w-md gap-6 text-center text-black dark:text-white"
        >
          <SeoTitle className="text-xl">Something went wrong!</SeoTitle>

          <pre className="whitespace-pre-wrap">{error.message}</pre>

          <p className="text-gray-500">
            Please try refreshing the page or check your connection.
          </p>

          <Button
            type="default"
            className="btn-primary mx-auto"
            onClick={resetErrorBoundary}
          >
            Try again
          </Button>
        </div>
      </ContainerFluid>
    </Section>
  );
}
